// Show page loader when .show-waiting elements trigger navigation or valid form submit
document.addEventListener('DOMContentLoaded', function () {
    const loading = document.getElementById('loading');
    if (!loading) return;

    // Links: show spinner on click
    document.querySelectorAll('a.show-waiting').forEach(function (el) {
        el.addEventListener('click', function () {
            loading.classList.remove('d-none');
        });
    });

    // Submit buttons: show spinner only when the form passes validation
    document.querySelectorAll('button[type="submit"].show-waiting').forEach(function (btn) {
        const form = btn.closest('form');
        if (form) {
            form.addEventListener('submit', function () {
                if (form.checkValidity()) {
                    loading.classList.remove('d-none');
                }
            });
        }
    });
});


// Elimina l'effetto freezing sue si torna indietro dal form
window.addEventListener('pageshow', function (event) {
    if (!event.persisted) return;
    const loading = document.getElementById('loading');
    if (loading) loading.classList.add('d-none');
});
